import as from './AS/Config';

export default {
  ...as,
};
